import React from 'react';
import { useIntl } from 'react-intl';
import { Lx } from '../../../i18n/consts';
import styles from './action-cancel-buttons-area.module.scss';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

interface Props {
    idActionLocalization?: string;
    idCancelLocalization?: string;
    onCancel: () => void;
    onAction: () => void;
    disabled?: boolean;
}

export const ActionCancelButtonsArea: React.FC<Props> = ({
    idActionLocalization,
    idCancelLocalization,
    onCancel,
    onAction,
    disabled
}) => {
    const isMobile = useMediaQuery({ maxWidth: 1000  });
    const intl = useIntl();
    const actionText = idActionLocalization ? intl.formatMessage({ id: idActionLocalization }): intl.formatMessage({ id: Lx.General.SAVE });;
    const cancelText = idCancelLocalization ? intl.formatMessage({ id: idCancelLocalization }) : intl.formatMessage({ id: Lx.General.CANCEL });

    return(
        <>
            {isMobile 
                ? <>
                    <button
                        onClick={() => onAction()}
                        className={styles.buttonActionCancelArea}
                        disabled={disabled}
                        autoFocus>
                        {actionText}
                    </button>
                    <button onClick={() => onCancel()} className={classNames({[styles.buttonActionCancelArea]: true, [styles.cancel]: true})} disabled={disabled}>
                        {cancelText}
                    </button>
                </>
                : <>
                    <button onClick={onCancel} className={classNames({[styles.buttonActionCancelArea]: true, [styles.cancel]: true})} disabled={disabled}>
                        {cancelText}
                    </button>
                    <button
                        onClick={() => onAction()}
                        className={styles.buttonActionCancelArea}
                        disabled={disabled}
                        autoFocus>
                        {actionText}
                    </button>
                </>
            }
        </>
    )

};
